module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/PQMYhk/tc-custom/9781937384975.jpg?1725723386521",
      "alt": "This image is the cover for the book Spinsters in Jeopardy, Roderick Alleyn"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Spinsters in Jeopardy, Roderick Alleyn\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A British police detective looks into sinister doings in the South of France in a crime thriller with “more than a little excitement” ("), _c('i', [_vm._v("Kirkus Reviews")]), _vm._v(").")]), _c('br'), _c('br'), _vm._v(" Inspector Roderick Alleyn has decamped for the South of France on a family vacation—though for him, the vacation will involve some official poking around. Unfortunately, the object of his poking—the cultish denizens of a sinister and luxurious chateau—are not fond of being poked, and they have a particularly unpleasant way of getting their point across . . ."), _c('br'), _c('br'), _vm._v(" “Charming, cultivated, witty—and none the less terrifying . . .a pure thriller . . .you’re not apt to find a better evening’s entertainment.” —"), _c('i', [_vm._v("The New York Times")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Ngaio Marsh\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Ngaio Marsh (1895-1982) was one of the celebrated queens of the Golden Age of detective fiction; born in New Zealand, she wrote 32 novels in the \"Inspector Alleyn\" series.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Felony & Mayhem Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0